/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GirConfig } from '../../models/gir-config';

export interface ListGirConfigurations$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The Badgeur Uid.
 */
  badgeurUid: string;
}

export function listGirConfigurations(http: HttpClient, rootUrl: string, params: ListGirConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GirConfig>>> {
  const rb = new RequestBuilder(rootUrl, listGirConfigurations.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('badgeurUid', params.badgeurUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GirConfig>>;
    })
  );
}

listGirConfigurations.PATH = '/custom/stations/{uid}/badgeur/{badgeurUid}/gir';
